import type { AgentBucket } from "@/components/reporting/agent-buckets"

export type OutcomeCounts = Record<AgentBucket, number>

/** Widths for the split bar, resolved first so it reads as the resolution rate. */
export const outcomeShares = (
	counts: OutcomeCounts,
): { bucket: AgentBucket; share: number }[] => {
	const total = counts.resolved + counts.escalated + counts.pending
	if (total === 0) return []
	return (["resolved", "escalated", "pending"] as const)
		.map((bucket) => ({ bucket, share: counts[bucket] / total }))
		.filter((segment) => segment.share > 0)
}
